import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosCreateInvoiceFromSalesExportController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosCreateInvoiceFromSalesExportController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/invoice'
*/
const EnaosCreateInvoiceFromSalesExportController = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: EnaosCreateInvoiceFromSalesExportController.url(args, options),
    method: 'post',
})

EnaosCreateInvoiceFromSalesExportController.definition = {
    methods: ["post"],
    url: '/api/funeral-home/{funeral_home}/enaos/sales-export/invoice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosCreateInvoiceFromSalesExportController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosCreateInvoiceFromSalesExportController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/invoice'
*/
EnaosCreateInvoiceFromSalesExportController.url = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { funeral_home: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home: typeof args.funeral_home === 'object'
        ? args.funeral_home.id
        : args.funeral_home,
    }

    return EnaosCreateInvoiceFromSalesExportController.definition.url
            .replace('{funeral_home}', parsedArgs.funeral_home.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosCreateInvoiceFromSalesExportController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosCreateInvoiceFromSalesExportController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/invoice'
*/
EnaosCreateInvoiceFromSalesExportController.post = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: EnaosCreateInvoiceFromSalesExportController.url(args, options),
    method: 'post',
})

export default EnaosCreateInvoiceFromSalesExportController